import { render, staticRenderFns } from "./EmailStep.vue?vue&type=template&id=42a42b0d&scoped=true"
import script from "./EmailStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailStep.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EmailStep.vue?vue&type=style&index=0&id=42a42b0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a42b0d",
  null
  
)

export default component.exports